module.exports = __webpack_public_path__ + "media/images/top/hako_size-48eb28ec6259e874ae48407a596d910e.jpg";